import { Draft, produce } from 'immer';
import { getFavorites, saveFavorites } from './favoriteStorage';
import { DesignsActionTypes, DesignsActions, DesignsState } from './types';

const INITIAL_STATE: DesignsState = {
  detail: {},
  favorites: [],
};

export const getInitialDesignState = () =>
  produce<DesignsState>(INITIAL_STATE, (draft) => {
    const favorites = getFavorites();
    if (favorites.length > 0) {
      draft.favorites = favorites;
    }
    return draft;
  });

export const designsReducer = produce((draft: Draft<DesignsState>, action: DesignsActions) => {
  switch (action.type) {
    case DesignsActionTypes.DESIGNS_FETCH:
      draft.detail[action.payload.id] = action.payload;
      return draft;
    case DesignsActionTypes.TOGGLE_FAVORITE:
      const toggleIndex = draft.favorites.indexOf(action.designId);
      if (toggleIndex >= 0) {
        draft.favorites.splice(toggleIndex, 1);
      } else {
        draft.favorites.push(action.designId);
      }
      saveFavorites(draft.favorites);
      return draft;
    case DesignsActionTypes.UPDATE_FAVORITE:
      const updateIndex = draft.favorites.indexOf(action.deprecatedDesignId);
      if (updateIndex >= 0) {
        draft.favorites.splice(updateIndex, 1, action.designId);
        saveFavorites(draft.favorites);
      }
      return draft;
    default:
      return draft;
  }
}, INITIAL_STATE);
